import { useCallback } from 'react';

export const useYupValidationResolver = validationSchema =>
    useCallback(
        async (data, context) => {
            try {
                const values = await validationSchema.validate(data, {
                    abortEarly: false,
                    context,
                });
                return {
                    values,
                    errors: {},
                };
            } catch (errors) {
                return {
                    values: {},
                    errors: errors.inner.reduce(
                        (allErrors, currentError) => ({
                            ...allErrors,
                            [currentError.path]: {
                                type: currentError.type ?? 'validation',
                                message: currentError.message,
                            },
                        }),
                        {},
                    ),
                };
            }
        },
        [validationSchema],
    );
